var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EF502307-0E72-4BD0-8129-1C5E0DA1B9A3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-1022.000000, -1518.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PieChart",
    transform: "translate(1022.000000, 1518.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-49",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-63",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 90,
    height: 70
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(11.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "%38",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 3,
    fontWeight: 500,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 62,
    y: 12
  }, "%38")), /*#__PURE__*/React.createElement("text", {
    id: "%32",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 3,
    fontWeight: 500,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 62,
    y: 21
  }, "%32")), /*#__PURE__*/React.createElement("text", {
    id: "%25",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 3,
    fontWeight: 500,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 62,
    y: 30
  }, "%25")), /*#__PURE__*/React.createElement("text", {
    id: "%5",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 3,
    fontWeight: 500,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 62,
    y: 39
  }, "%5")), /*#__PURE__*/React.createElement("g", {
    id: "Group-40-Copy",
    transform: "translate(12.500000, 25.000000) scale(-1, 1) rotate(-180.000000) translate(-12.500000, -25.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,25 L25,0 C11.1928813,0 0,11.1928813 0,25 C0,29.2131558 1.0421994,33.1828929 2.88285528,36.6654684 L25,25 Z",
    id: "Oval-Copy-22",
    fill: "#C3C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,50 L25,25 L2.88285528,36.6654684 C7.07429396,44.5957946 15.4060371,50 25,50 Z",
    id: "Oval-Copy-23",
    fill: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-40-Copy",
    transform: "translate(37.500000, 25.000000) rotate(-180.000000) translate(-37.500000, -25.000000) translate(25.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,25 L0,25 C0,29.2131558 1.0421994,33.1828929 2.88285528,36.6654684 L25,25 Z",
    id: "Oval-Copy-22",
    fill: "#777575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,25 L25,0 C11.1928813,0 7.47939722e-15,11.1928813 7.47939722e-15,25 L25,25 Z",
    id: "Oval-Copy-22",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,50 L25,25 L2.88285528,36.6654684 C7.07429396,44.5957946 15.4060371,50 25,50 Z",
    id: "Oval-Copy-23",
    fill: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E9E9E9",
    cx: 56.7105263,
    cy: 10.7105263,
    r: 1.71052632
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    fill: "#C3C1C1",
    cx: 56.7105263,
    cy: 19.7105263,
    r: 1.71052632
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-25",
    fill: "#8F8F8F",
    cx: 56.9736842,
    cy: 28.7105263,
    r: 1.71052632
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-26",
    fill: "#777575",
    cx: 56.7105263,
    cy: 37.7105263,
    r: 1.71052632
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/PieChart.445ebf17dde88b884a7bfab34fac38a1.svg";
export { ForwardRef as ReactComponent };